import $ from 'jquery'
global.jQuery = $
window.jQuery = $

export default {
  name: 'treatment-salary-list',
  methods: {
    goTop: function () {
      this.$router.push({path: '/'})
    },
    goTreatmentLeaveList: function () {
      this.$router.push({ path: '/treatment_leave_list' })
    },
    goTreatmentRuleList: function () {
      this.$router.push({ path: '/treatment_rule_list' })
    },
    goTreatmentDetail: function (pass) {
      this.$router.push({ path: '/treatment_detail/' + pass })
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/treatment-salary-list.js